import { useEffect, useState } from 'react';

import * as Sentry from '@sentry/react';
import { captureCustomException } from 'App/Services/ErrorTracking/captureCustomException';

export const useGameLoadError = ({
    addEventListener,
    removeEventListener,
    initialisationError,
}) => {
    const [gameLoadError, setGameLoadError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [initError, setInitError] = useState(null);

    useEffect(() => {
        if (initialisationError) {
            setInitError(initialisationError || true);

            captureCustomException(initialisationError, 'GameInitError');
        }
    }, [initialisationError]);

    useEffect(() => {
        const handleError = (message) => {
            setGameLoadError(true);
            setErrorMessage(message);
            Sentry.captureException(
                new Error(`Game Load Error. ${message || ''}`)
            );
        };

        addEventListener('error', handleError);

        return () => {
            removeEventListener('error', handleError);
        };
    }, [addEventListener, removeEventListener]);

    return { gameLoadError, errorMessage, initError };
};
